const Input = {
  defaultProps: {
    focusBorderColor: "limeShade.600",
  },
};

export default Input;
